import { motion } from "framer-motion";

const DETAILS = [
  { tag: "TIBEB", text: "the woven border pattern of the highlands" },
  { tag: "GOLD THREAD", text: "worked entirely by hand, edge by edge" },
  { tag: "LINEAGE", text: "patterns inherited, never merely copied" },
];

export default function Embroidery() {
  return (
    <section id="craft" data-testid="craft-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-10 lg:px-16 lg:py-36">
      <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-20">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold/80">THE CRAFT</p>
          <h2 className="mt-4 font-display text-2xl tracking-tight text-cream sm:text-3xl lg:text-4xl">
            The Language of Gold Thread
          </h2>
          <p className="mt-5 max-w-lg text-base font-light leading-relaxed text-stone2 sm:text-lg">
            Every stitch of a kaba&rsquo;s embroidery carries a language of its own —
            patterns passed from mother to daughter, from master to apprentice, traced
            in gold along the neck, down the middle opening, and around the curve of
            the hem. To read a kaba is to read a family tree.
          </p>
          <ul className="mt-8 space-y-4 border-t border-gold/15 pt-8">
            {DETAILS.map((d) => (
              <li key={d.tag} className="flex items-baseline gap-5" data-testid={`craft-detail-${d.tag.toLowerCase().replace(/\s+/g, "-")}`}>
                <span className="w-28 shrink-0 font-mono text-[11px] uppercase tracking-[0.2em] text-gold">{d.tag}</span>
                <span className="text-sm font-light text-muted2 sm:text-base">{d.text}</span>
              </li>
            ))}
          </ul>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="group relative overflow-hidden border border-gold/20">
            <img
              src="/images/history/scene_04.png"
              alt="Hands embroidering gold thread onto velvet in an atelier"
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
